import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DbTemplate, Department } from '../template.model';
import { TemplateService } from '../template.service';
import { DepartmentService } from 'src/app/services/department.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-template-create',
    templateUrl: './template-create.component.html',
    styleUrl: './template-create.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})

export class TemplateCreateComponent implements OnInit {

  
  currentDepartment: Department = {} as Department;

  isCreateingTemplate: boolean = false;
  isLoading: boolean = true;

  loadingText: string = 'Henter skabeloner...';
  dbTables: DbTemplate[] = [];
  dbTemplateId: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private templateService: TemplateService,
    private departmentService: DepartmentService,
    private toastrService: ToastrService,
    private router: Router

  ) { 
    this.currentDepartment = this.departmentService.getDepartment();
  }

  async ngOnInit(): Promise<void> {

    this.dbTables = await this.templateService.getAvailableTemplates();
    this.dbTables.unshift({id: '', tableName: 'Vælg databaseskabelon'} as DbTemplate);       
    this.isLoading = false;
  }

  disabled(): boolean {
    if (this.dbTemplateId.length > 0 && ! this.isCreateingTemplate)
    {
      return false;
    }
    return true;
  }

  ondbTableChange($event: any): void {
    this.dbTemplateId = $event.target.value;
  }

  createTemplate(): void {  
    this.isCreateingTemplate = true;
    this.templateService.createDbTemplate(this.currentDepartment.id, this.dbTemplateId).then((newid: string) => {
      this.toastrService.success("Skabelon oprettet");
      this.router.navigate(['/template/'+ newid]);      
      this.activeModal.close("close click");

    }).catch(() => {
      // HTTP-fejl vises globalt af GlobalErrorInterceptor/ErrorService
    }).finally(() => {
      this.isCreateingTemplate = false;
    });
  }
}
